import React, { FormEvent, useContext, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { TranslationContext } from '../../contexts/TranslationContext';
import { DeliveryType, IOrderSolutionRequest, IPostalAddress, IUserSolution, PostalAddress } from '../../services/WebApiClient';
import { useState2 } from '../../util/useState2';
import { PostalAddressEditor } from './PostalAddressEditor';


export function OrderModal(props: {
    us: IUserSolution;
    onClose: (orderInfo: IOrderSolutionRequest | undefined) => void;

}) {

    const tc = useContext(TranslationContext);
    const billingAddress = useState2<IPostalAddress>({
        name: "",
        address1: "",
        address2: "",
        city: "",
        country: tc.translator("order modal default country", "Danmark"),
        caseId: "",
        phone: "",
        postalCode: ""
    });
    const [deliveryType, setDeliveryType] = useState<DeliveryType>(DeliveryType.BillingAddress);

    function submit(evt?: FormEvent) {
        evt?.preventDefault();
        const result: IOrderSolutionRequest = {
            customerAddress: new PostalAddress(billingAddress.value),
            deliveryType: deliveryType
        };
        props.onClose(result);
    }

    function setDeliveryType2(evt: React.ChangeEvent<HTMLSelectElement>) {
        const strVal = evt.target.value;
        const intVal = parseInt(strVal);
        setDeliveryType(intVal);
    }

    return (
        <Modal onHide={() => props.onClose(undefined)}
            animation={false}
            show
            centered
            scrollable

        >
            <form onSubmit={submit}>
                <Modal.Header
                    closeButton
                    closeLabel={tc.translator("modal close label", "Luk")}>
                    <Modal.Title>
                        {tc.translator("order modal header", "Bestil {name}", { name: props.us.name })}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    {(props.us.errorFlags !== 0) && <div className="alert alert-warning">
                        {tc.translator(
                            "save modal errors",
                            "Din løsning indeholder en eller flere fejl, som du bør rette inden bestilling."
                        )}
                    </div>}

                    <select onChange={setDeliveryType2}
                        value={deliveryType}
                        className="form-control"
                        style={{marginBottom:"15px"}}
                    >
                        <option value={DeliveryType.BillingAddress}>
                            {tc.translator("delivery type BillingAddress","Leveres hos kunden")}
                        </option>
                        <option value={DeliveryType.StoreAddress}>
                            {tc.translator("delivery type StoreAddress", "Leveres til butik")}
                        </option>
                    </select>

                    <PostalAddressEditor postalAddress={billingAddress} disabled={deliveryType !== DeliveryType.BillingAddress} />

                </Modal.Body>

                <Modal.Footer>
                    <button type="submit" className="btn btn-success"
                        onClick={() => /* handled by the form */1}
                    >
                        {tc.translator("order modal button", "Bestil Løsning")}
                    </button>
                </Modal.Footer>

            </form>
        </Modal>
    );
}
